// Icons + action buttons for JS-built rows (tablebtn#1).
// Mirrors templates/partials/_icon.html: an <svg class="ls-icon"> that points at a symbol of the sprite in
// templates/partials/_icon_sprite.html (`#i-<name>`). DOM is built with createElementNS — never innerHTML.

const SVG_NS = "http://www.w3.org/2000/svg"

export const ACT_VARIANTS = ["danger", "success", "primary", "warning", "neutral"]

export function icon(name) {
  const svg = document.createElementNS(SVG_NS, "svg")
  svg.setAttribute("class", "ls-icon")
  svg.setAttribute("aria-hidden", "true")
  svg.setAttribute("focusable", "false")
  const use = document.createElementNS(SVG_NS, "use")
  use.setAttribute("href", `#i-${name}`)
  svg.append(use)
  return svg
}

// A whole action button: <button class="ls-act ls-act--<variant>"><svg class="ls-icon"/><span class="ls-act__label">…</span></button>
export function actButton({ label, iconName, variant, tag = "button" }) {
  if (!ACT_VARIANTS.includes(variant)) throw new Error(`unknown action variant: ${variant}`)
  const el = document.createElement(tag)
  if (tag === "button") el.type = "button"
  el.className = `ls-act ls-act--${variant}`
  const text = document.createElement("span")
  text.className = "ls-act__label"
  text.textContent = label
  el.append(icon(iconName), text)
  return el
}

// Set label + icon + colour in one go (state-dependent row buttons: Dezaktywuj <-> Aktywuj).
export function applyAct(btn, { label, iconName, variant }) {
  setActLabel(btn, label)
  setActIcon(btn, iconName)
  setActVariant(btn, variant)
}

// The label text of an action button (falls back to the whole button for markup without the label span).
export function getActLabel(btn) {
  return (btn.querySelector(".ls-act__label") ?? btn).textContent
}

// Replace the label WITHOUT losing the icon (`btn.textContent = …` would wipe the <svg>).
export function setActLabel(btn, text) {
  const label = btn.querySelector(".ls-act__label")
  if (label) label.textContent = text
  else btn.textContent = text
}

// Swap the symbol an action button shows (e.g. power <-> power-off on the Ulubione toggle).
export function setActIcon(btn, name) {
  btn.querySelector("use")?.setAttribute("href", `#i-${name}`)
}

// Swap the semantic colour: exactly one `ls-act--*` modifier stays on the button.
export function setActVariant(btn, variant) {
  if (!ACT_VARIANTS.includes(variant)) throw new Error(`unknown action variant: ${variant}`)
  for (const v of ACT_VARIANTS) btn.classList.remove(`ls-act--${v}`)
  btn.classList.add(`ls-act--${variant}`)
}
